import { images } from './ImageUrls';

export const ExperiemntImageData = {
  _id: '60869b6b2917195cd6392a3cddddd', // random Id
  language: ['en', 'hi'],
  stage: ['ttc', 'pregnant', 'mother'],
  default_collapsed: false,
  status: true,
  product_id: 979,
  type: {
    key: 'media',
    value: 'Banner',
  },
  title: '',
  hindi_title: '',
  content_align: 'bottom',
  grid_column: null,
  widgetContent: [
    {
      _id: '60869b6b2917195cd6392a3cddddd', // random Id
      heading: '',
      hindi_heading: '',
      body: '',
      hindi_body: '',
      url: images.expert_consultation,
      hindi_url: images.expert_consultation,
      list: [],
      fallbackAltName: 'smc_expert_consultation',
    },
  ],
  position: 1,
  __v: 0,
  platform: 1,
  version: 1,
  policy_id: '6298ab111364b35b916df07d',
};
